import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import { setToastInstance } from '@/utils/displayError';
import initSentry from '@/utils/sentry';
import { applyBrandColor } from '@/utils/theme';
import App from './App.vue';
import { i18n } from './i18n';
import pt from './pt';
import router from './router';
import '@/style.scss';

applyBrandColor();

const app = createApp(App);

const pinia = createPinia();

const vFocus = {
  mounted: (el: any) =>
    el.querySelector('input') ? el.querySelector('input').focus() : el.focus(),
  updated(el: any, binding: any, vnode: any, prevVnode: any) {
    if (prevVnode.props?.disabled && !vnode.props?.disabled) {
      el.querySelector('input') ? el.querySelector('input').focus() : el.focus();
    }
  },
};

app.use(i18n);
app.use(pinia);
app.use(router);
app.use(ToastService);
app.directive('tooltip', Tooltip);
app.directive('focus', vFocus);
app.use(PrimeVue, { unstyled: true, pt });

setToastInstance(app.config.globalProperties.$toast);

initSentry(app, router);

app.mount('#app');

export default app;
